import Vue from 'vue'
import EditLayer from './EditLayer.vue'

const EditLayerConstructor = Vue.extend(EditLayer)
const instance = new EditLayerConstructor({
  el: document.createElement('div')
})

instance.vm = instance.$mount()
document.body.appendChild(instance.vm.$el)

Vue.prototype.$editLayer = instance

export default instance



// WEBPACK FOOTER //
// ./src/components/EditLayer/index.js